import React, { Component } from 'react';
import './Static.css';
let CSS_ANIMATION_DURATION = 300;

class Static extends Component {
  constructor(context, props) {
    super(context, props);
    this.state = {openNeeded:false, open: false};
  }

  open() {
    this.setState({...this.state, openNeeded: true});
    setTimeout(function(){
      let { openNeeded } = this.state;
      if (openNeeded) this.setState({...this.state, open: true});
    }.bind(this), CSS_ANIMATION_DURATION);
  }

  ComponentDidMount() {
    let { open } = this.props;
    if (open) {
      this.open();
    } else {
      this.setState({...this.state, openNeeded: false, open: false});
    }
  }

  componentWillReceiveProps(nextProps) {
    let { open } = nextProps;
    if (open) {
      this.open();
    } else {
      this.setState({...this.state, openNeeded: false, open: false});
    }
  }

  render() {
    let { open, openNeeded } = this.state;
    return (
      <div className={"Static" + (openNeeded ? " Static--openNeeded" : "") + (open ? " Static--open" : " Static--hidden")} >
          <div className="Wrapper Static__wrapper">
            <h1 className="Static__header">Создаём и ведём свои проекты в интернете</h1>
            <div className="Static__projects">
              <a className="Static__link Static__project" href="https://spbguru.ru">СПБгуру</a>
              <a className="Static__link Static__project" href="https://mskguru.ru">МСКгуру</a>
              <a className="Static__link Static__project" href="https://ama.ru">AMA</a>
            </div>
            <div className="Static__contacts">
              <p className="Static__contact">СПб, ул. Рижская, 5</p>
              <p className="Static__contact"><a className="Static__link" href="tel:+79319791595">+7 931 979 15 95</a></p>
              <p className="Static__contact"><a className="Static__link" href="mailto:hello@amagroup.ru">hello@amagroup.ru</a></p>

            </div>
          </div>
      </div>
    );
  }
}

export default Static;



/** WEBPACK FOOTER **
 ** ./src/components/Static/index.js
 **/